module.exports = __webpack_public_path__ + "static/media/trash.f87f4cf4.svg";